import React from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { formatToTime } from "../../master/FormatToDateTime";

export default function AttendanceCalendar({ attendances, setFilters }) {
  const localizer = momentLocalizer(moment);
  const mapAttendanceToEvents = (attendances) => {
    const map = {};
    attendances?.forEach((att) => {
      const date = att.date;
      if (!map[date] || (att.check_out_time && !map[date].check_out_time)) {
        map[date] = att;
      }
    });

    return Object.values(map).map((att) => {
      const start = moment(
        att.date + " " + (att.check_in_time || "00:00:00")
      ).toDate();
      const end = att.check_out_time
        ? moment(att.date + " " + att.check_out_time).toDate()
        : moment(att.date + " 23:59:00").toDate();

      return {
        start,
        end,
        resource: att,
      };
    });
  };

  const events = mapAttendanceToEvents(attendances);

  const eventStyleGetter = (event) => {
    const att = event.resource;

    let style = {
      borderRadius: "6px",
      color: "#fff",
      border: "none",
      padding: "2px 6px",
      fontWeight: "500",
    };

    if (att.check_in === "2") {
      style.backgroundColor = "#dc3545";
    } else if (att.check_in === "1" && !att.check_in_time) {
      style.backgroundColor = "#28a745";
    } else if (att.check_out === "2") {
      style.backgroundColor = "#ffc107";
      style.color = "#000";
    } else {
      style.backgroundColor = "#28a745";
    }

    return { style };
  };

  const EventComponent = ({ event }) => {
    const att = event.resource;

    return (
      <div
        title={`In: ${formatToTime(att.check_in_time) || "--"} | Out: ${formatToTime(att.check_out_time) || "--"
          }`}
        style={{ fontSize: "14px" }}
      >
        {att.check_in === "2" ? (
          <p className="m-0 text-center">Absent</p>
        ) : att.check_in_time || att.check_out_time ? (
          <div style={{ fontSize: "10px" }}>
            <p className="m-0">
              In: {formatToTime(att.check_in_time)}
            </p>
            {att.check_out_time && (
              <p className="m-0">Out: {formatToTime(att.check_out_time)}</p>
            )}
          </div>
        ) : (
          <p className="m-0 text-center">Present</p>
        )}
      </div>
    );
  };
  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <div style={{ height: "600px" }}>
              <Calendar
                localizer={localizer}
                events={events}
                startAccessor="start"
                endAccessor="end"
                views={["month", "week", "day"]}
                defaultView="month"
                eventPropGetter={eventStyleGetter}
                components={{
                  event: EventComponent,
                }}
                onNavigate={(date) => {
                  setFilters((prev) => ({
                    ...prev,
                    month: moment(date).format("YYYY-MM"),
                  }));
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
